'use client';

import { useState, type FormEvent } from 'react';

import { subscribeNewsletter } from '@/entities/customer/client';
import { ApiError } from '@/shared/api';

import styles from './newsletter-form.module.scss';

export function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [consent, setConsent] = useState(false);
  const [status, setStatus] = useState<{ tone: 'ok' | 'error'; text: string } | null>(null);
  const [pending, setPending] = useState(false);

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email.trim())) {
      setStatus({ tone: 'error', text: 'Проверьте email' });
      return;
    }
    if (!consent) {
      setStatus({ tone: 'error', text: 'Отметьте согласие на рассылку' });
      return;
    }
    setPending(true);
    try {
      await subscribeNewsletter(email.trim());
      setStatus({ tone: 'ok', text: 'Спасибо! Вы подписались на рассылку' });
      setEmail('');
    } catch (error) {
      setStatus({
        tone: 'error',
        text:
          error instanceof ApiError ? error.message : 'Не удалось подписаться. Попробуйте позже',
      });
    } finally {
      setPending(false);
    }
  };

  return (
    <form
      className={styles.root}
      onSubmit={(event) => {
        void submit(event);
      }}
      noValidate
    >
      <p className={styles.title}>Подпишитесь на рассылку бренда</p>
      <div className={styles.row}>
        <label htmlFor="newsletter-email" className={styles.hidden}>
          Email
        </label>
        <input
          id="newsletter-email"
          className={styles.input}
          type="email"
          placeholder="Email"
          autoComplete="email"
          value={email}
          onChange={(event) => {
            setEmail(event.target.value);
            setStatus(null);
          }}
        />
        <button
          type="submit"
          className={styles.button}
          disabled={pending}
          aria-busy={pending || undefined}
        >
          Подписаться
        </button>
      </div>
      <label className={styles.consent}>
        <input
          type="checkbox"
          className={styles.check}
          checked={consent}
          required
          onChange={(event) => {
            setConsent(event.target.checked);
            setStatus(null);
          }}
        />
        <span>[текст согласия]</span>
      </label>
      {status && (
        <output className={styles.status} data-tone={status.tone}>
          {status.text}
        </output>
      )}
    </form>
  );
}
